import React from 'react';
import t from 'prop-types';
import { BotonImagen } from '../botones';

var BotonCajaMiniaturas = function BotonCajaMiniaturas(_ref) {
  var desactivado = _ref.desactivado,
      onClick = _ref.onClick,
      children = _ref.children;
  return React.createElement(BotonImagen, {
    clases: 'botonCajaMiniaturas',
    desactivado: desactivado,
    onClick: onClick
  }, children);
};

BotonCajaMiniaturas.propTypes = process.env.NODE_ENV !== "production" ? {
  desactivado: t.bool,
  onClick: t.func,
  children: t.node
} : {};
export default BotonCajaMiniaturas;